import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../api/apiClient';

export const fetchRecentTransactions = createAsyncThunk(
  'transaction/fetchRecent',
  async (portfolioId, thunkAPI) => {
    try {
      const response = await apiClient.get(`/transactions?portfolioId=${portfolioId}&page=1&limit=5&sortDirection=desc`);
      return response.data.transactions;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Failed to fetch recent transactions');
    }
  }
);

export const fetchTransactions = createAsyncThunk(
  'transaction/fetchTransactions',
  async ({ portfolioId, page = 1, limit = 10 }, thunkAPI) => {
    try {
      const response = await apiClient.get(
        `/transactions?portfolioId=${portfolioId}&page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Failed to fetch transactions');
    }
  }
);

export const createTransaction = createAsyncThunk(
  'transaction/createTransaction',
  async (transactionData, thunkAPI) => {
    try {
      const response = await apiClient.post('/transactions', transactionData);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Failed to create transaction');
    }
  }
);

export const deleteTransaction = createAsyncThunk(
  'transaction/deleteTransaction',
  async ({ portfolioId, transactionId }, thunkAPI) => {
    try {
      await apiClient.delete(`/transactions/${transactionId}?portfolioId=${portfolioId}`);
      return { portfolioId, transactionId }; // Pass portfolioId for potential refreshing
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Failed to delete transaction');
    }
  }
);

const transactionSlice = createSlice({
  name: 'transaction',
  initialState: {
    recent: [],
    fetchRecentStatus: 'idle',
    paginated: [],
    total: 0,
    fetchStatus: 'idle',
    createStatus: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecentTransactions.pending, (state) => {
        state.fetchRecentStatus = 'loading';
      })
      .addCase(fetchRecentTransactions.fulfilled, (state, action) => {
        state.fetchRecentStatus = 'succeeded';
        state.recent = action.payload;
      })
      .addCase(fetchRecentTransactions.rejected, (state, action) => {
        state.fetchRecentStatus = 'failed';
        state.error = action.payload;
      })

      .addCase(fetchTransactions.pending, (state) => {
        state.fetchStatus = 'loading';
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.fetchStatus = 'succeeded';
        state.paginated = action.payload.transactions;
        state.total = action.payload.total;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.fetchStatus = 'failed';
        state.error = action.payload;
      })

      .addCase(createTransaction.fulfilled, (state) => {
        state.createStatus = 'succeeded';
      })

      .addCase(deleteTransaction.fulfilled, (state, action) => {
        state.paginated = state.paginated.filter(
          (transaction) => transaction._id !== action.payload.transactionId
        );
        state.deleteStatus = 'succeeded';
      })
      .addCase(deleteTransaction.rejected, (state) => {
        state.deleteStatus = 'failed';
      });
  },
});

export const { 
  fetchRecentStatus,
} = transactionSlice.actions;
export default transactionSlice.reducer;